<template>
  <nna-container :spacing=10>
    <nna-shops-list />
  </nna-container>
</template>

<script>
import nnaShopsList from '@/modules/common/components/list/Shops'
export default {
  name: 'Shops',
  components: {
    nnaShopsList,
  },
  data() {
    return {
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/shop/pages/Shops.vue